export default __webpack_public_path__ + "static/media/icon_logo.2ae38ec2.ico";